import styled from '@emotion/styled';
import React from 'react';
import MuiButton, { ButtonProps, buttonClasses } from '@mui/material/Button';

const StyledMuiButton = styled(MuiButton)`
    &.${buttonClasses.root} {
        font-family: NotoSans, Helvetica, sans-serif;
        text-transform: none;
        border-radius: 8px;
        box-shadow: none;
        font-style: normal;
        font-weight: 600;

        &:hover,
        &:focus {
            box-shadow: none;
        }

        &.${buttonClasses.disabled} {
            opacity: 0.5;
        }
    }

    &.${buttonClasses.containedPrimary},
        &.${buttonClasses.containedPrimary}.${buttonClasses.disabled} {
        color: #fff;
        background-color: ${(props) => props.theme.colorsUnifications.azure['100']};

        &:hover,
        &:focus {
            background-color: ${(props) => props.theme.colorsUnifications.cerulean['100']};
        }
    }

    &.${buttonClasses.outlinedPrimary},
        &.${buttonClasses.outlinedPrimary}.${buttonClasses.disabled} {
        border-width: 2px;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.02);
        background-color: ${(props) => props.theme.colorsUnifications.aliceBlue['100']};
        border-color: ${(props) => props.theme.colorsUnifications.cornFlower['100']};
        color: ${(props) => props.theme.colorsUnifications.azure['100']};

        &:hover,
        &:focus {
            border-width: 2px !important;
            border-color: ${(props) => props.theme.colorsUnifications.freshAir[100]};
            background-color: ${(props) => props.theme.colorsUnifications.sky[100]};
        }
    }

    &.${buttonClasses.sizeMedium} {
        padding: 9px 24px;
        font-size: 14px;
        line-height: 22px;
    }

    &.${buttonClasses.sizeLarge} {
        font-size: 16px;
        line-height: 24px;
        padding: 12px 24px;
    }
`;

export const Button = ({ children, color, variant, ...props }: ButtonProps) => {
    return (
        <StyledMuiButton
            disableRipple
            color={color || 'primary'}
            variant={variant || 'contained'}
            {...props}
        >
            {children}
        </StyledMuiButton>
    );
};
